import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseclient';

// Importação das páginas
import Login from './paginas/login';
import Dashboard from './paginas/dashboard';
import Concessao from './paginas/concessao';
import Relatorios from './paginas/relatorios';
import Campanhas from './paginas/campanhas';
import Estoque from './paginas/estoque';
import Equipe from './paginas/equipe';
import Veiculos from './paginas/veiculos';
import Enxoval from './paginas/enxoval';
import RelatorioEnxoval from './paginas/relatorioenxoval';
import Cras1 from './paginas/cras1';
import Cras2 from './paginas/cras2';
import Creas from './paginas/creas';
import AdminDashboard from './paginas/AdminDashboard';

const CONFIG_DEPTOS = {
  fundo_social: {
    nome: 'Fundo Social',
    corBase: 'bg-blue-900',
    corDestaque: 'bg-blue-700',
    corTexto: 'text-blue-400',
    logo: '/logo-fundo-social-branco.png',
    titulo: 'Gestão Fundo Social'
  },
  cras_1: {
    nome: 'CRAS I',
    corBase: 'bg-green-900',
    corDestaque: 'bg-green-700',
    corTexto: 'text-green-400',
    logo: '/brasao-mirassol.png',
    titulo: 'Gestão CRAS I'
  },
  cras_2: {
    nome: 'CRAS II',
    corBase: 'bg-emerald-900',
    corDestaque: 'bg-emerald-700',
    corTexto: 'text-emerald-400',
    logo: '/brasao-mirassol.png',
    titulo: 'Gestão CRAS II'
  },
  creas: {
    nome: 'CREAS',
    corBase: 'bg-red-900',
    corDestaque: 'bg-red-700',
    corTexto: 'text-red-400',
    logo: '/brasao-mirassol.png',
    titulo: 'Gestão CREAS'
  }
};

export default function App() {
  const [sessao, setSessao] = useState(null);
  const [perfil, setPerfil] = useState(null);
  const [tela, setTela] = useState('dashboard');
  const [menuAberto, setMenuAberto] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSessao(session);
      if (session) buscarPerfil(session.user.id);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSessao(session);
      if (session) buscarPerfil(session.user.id);
      else setPerfil(null);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const escutarMudanca = (e) => setTela(e.detail);
    window.addEventListener('mudarTela', escutarMudanca);
    return () => window.removeEventListener('mudarTela', escutarMudanca);
  }, []);

  const buscarPerfil = async (userId) => {
    try {
      const { data, error } = await supabase
        .from('perfis')
        .select('nome, role, nivel, departamento')
        .eq('id', userId)
        .maybeSingle(); 

      if (data) {
        const dpto = data.departamento || 'fundo_social';
        const userRole = data.role || data.nivel || 'operador';
        
        setPerfil({ ...data, role: userRole, departamento: dpto });

        // Redirecionamento Automático ao logar
        if (userRole === 'admin') setTela('admin-geral');
        else if (dpto === 'cras_1') setTela('cras1');
        else if (dpto === 'cras_2') setTela('cras2');
        else if (dpto === 'creas') setTela('creas');
        else setTela('dashboard');
      }
    } catch (err) {
      setPerfil({ nome: 'Colaborador', role: 'operador', departamento: 'fundo_social' });
    }
  };

  const isAdmin = perfil?.role === 'admin';
  const tema = CONFIG_DEPTOS[perfil?.departamento] || CONFIG_DEPTOS.fundo_social;

  if (!sessao) return <Login />;

  return (
    <div className="flex h-screen w-full bg-gray-100 font-sans overflow-hidden">
      
      {/* MENU LATERAL */}
      <aside className={`
        ${menuAberto ? 'translate-x-0' : '-translate-x-full md:translate-x-0'} 
        fixed md:relative z-50 w-72 h-full ${tema.corBase} text-white p-6 
        transition-transform duration-300 ease-in-out no-print shadow-2xl shrink-0
      `}>
        <div className="flex flex-col items-center mb-10 border-b border-white/10 pb-6">
          <img src={tema.logo} alt="Logo" className="h-20 mb-4" />
          <h2 className="text-center font-black text-xs uppercase leading-tight tracking-widest">
            {tema.nome} <br/> de Solidariedade
            <span className={`block ${tema.corTexto} text-[9px] mt-1 font-bold italic`}>Mirassol - SP</span>
          </h2>
        </div>

        <nav className="flex flex-col gap-2 overflow-y-auto max-h-[calc(100vh-200px)] custom-scroll">
          <button onClick={() => {setTela('dashboard'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'dashboard' ? `${tema.corDestaque} shadow-lg scale-105` : 'hover:bg-black/10'}`}>🏠 Dashboard</button>
          
          <button onClick={() => {setTela('concessao'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'concessao' ? `${tema.corDestaque} shadow-lg scale-105` : 'hover:bg-black/10'}`}>🎁 Nova Concessão</button>
          
          {/* Seção Fundo Social */}
          {perfil?.departamento === 'fundo_social' && (
            <div className="bg-white/5 p-2 rounded-2xl space-y-1 my-1">
               <p className={`text-[9px] font-black ${tema.corTexto} uppercase px-2 mb-1 tracking-widest opacity-70`}>Enxovais</p>
               <button onClick={() => {setTela('enxoval'); setMenuAberto(false);}} className={`w-full p-3 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'enxoval' ? `${tema.corDestaque} shadow-lg` : 'hover:bg-black/10'}`}>👶 Cadastrar Kit</button>
               <button onClick={() => {setTela('relatorio-enxoval'); setMenuAberto(false);}} className={`w-full p-3 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'relatorio-enxoval' ? `${tema.corDestaque} shadow-lg` : 'hover:bg-black/10'}`}>📋 Relatório Enxoval</button>
            </div>
          )}

          {/* Botões das Unidades */}
          {perfil?.departamento === 'cras_1' && (
            <button onClick={() => {setTela('cras1'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'cras1' ? `${tema.corDestaque} shadow-lg scale-105` : 'hover:bg-black/10'}`}>🏢 Unidade CRAS I</button>
          )}
          {perfil?.departamento === 'cras_2' && (
            <button onClick={() => {setTela('cras2'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'cras2' ? `${tema.corDestaque} shadow-lg scale-105` : 'hover:bg-black/10'}`}>🏢 Unidade CRAS II</button>
          )}
          {perfil?.departamento === 'creas' && (
            <button onClick={() => {setTela('creas'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'creas' ? `${tema.corDestaque} shadow-lg scale-105` : 'hover:bg-black/10'}`}>⚖️ Unidade CREAS</button>
          )}

          <button onClick={() => {setTela('campanhas'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'campanhas' ? `${tema.corDestaque} shadow-lg scale-105` : 'hover:bg-black/10'}`}>🚚 Campanhas</button>
          <button onClick={() => {setTela('relatorios'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'relatorios' ? `${tema.corDestaque} shadow-lg scale-105` : 'hover:bg-black/10'}`}>📊 Relatórios</button>

          {isAdmin && (
            <div className="mt-4 pt-4 border-t border-white/10 space-y-2">
              <p className={`text-[10px] font-black ${tema.corTexto} uppercase px-4 mb-2 tracking-widest opacity-70`}>Admin</p>
              <button onClick={() => {setTela('admin-geral'); setMenuAberto(false);}} className={`w-full p-4 rounded-xl text-xs font-black flex items-center gap-3 transition-all ${tela === 'admin-geral' ? 'bg-white/20 shadow-lg scale-105' : 'hover:bg-white/10'}`}>📈 Painel Geral</button>
              <button onClick={() => {setTela('estoque'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'estoque' ? 'bg-orange-600 shadow-md' : 'hover:bg-orange-900/30'}`}>📦 Estoque</button>
              <button onClick={() => {setTela('veiculos'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'veiculos' ? 'bg-orange-600 shadow-md' : 'hover:bg-orange-900/30'}`}>🚗 Frota</button>
              <button onClick={() => {setTela('equipe'); setMenuAberto(false);}} className={`p-4 rounded-xl text-xs font-bold flex items-center gap-3 transition-all ${tela === 'equipe' ? 'bg-orange-600 shadow-md' : 'hover:bg-orange-900/30'}`}>👥 Equipe</button>
            </div>
          )}

          <button onClick={() => supabase.auth.signOut()} className="mt-6 p-4 rounded-xl text-[10px] font-black uppercase tracking-widest border border-red-500/30 text-red-400 hover:bg-red-600 hover:text-white transition-all text-center">🚪 Sair</button>
        </nav>
      </aside>

      {/* LADO DIREITO */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden bg-gray-100 relative">
        
        <header className={`${tema.corBase} h-16 border-b border-black/20 flex items-center px-8 shrink-0 no-print relative z-10`}>
          <button onClick={() => setMenuAberto(!menuAberto)} className="md:hidden text-2xl text-white">☰</button>
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <span className="text-[11px] font-black text-white uppercase tracking-[0.3em]">{tema.titulo}</span>
          </div>
          <div className="ml-auto flex items-center gap-4 z-10">
            <div className="text-right">
              <p className="text-xs font-black text-white leading-none uppercase">{perfil?.nome || 'Usuário'}</p>
              <p className={`text-[9px] ${tema.corTexto} font-bold uppercase mt-1 tracking-tighter`}>{perfil?.role || 'Acesso'}</p>
            </div>
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-white font-black text-[10px] border border-white/30 uppercase">{perfil?.nome?.substring(0,2)}</div>
          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-4 md:p-6 pb-14 custom-scroll">
          <div className="max-w-6xl mx-auto w-full">
            <div className="bg-white rounded-[2rem] shadow-xl border border-gray-100 p-4 md:p-8">
              {tela === 'dashboard' && <Dashboard />}
              {tela === 'concessao' && <Concessao />}
              {tela === 'campanhas' && <Campanhas />}
              {tela === 'relatorios' && <Relatorios />}
              {tela === 'enxoval' && <Enxoval />}
              {tela === 'relatorio-enxoval' && <RelatorioEnxoval />}
              {tela === 'cras1' && <Cras1 />}
              {tela === 'cras2' && <Cras2 />}
              {tela === 'creas' && <Creas />}
              {tela === 'admin-geral' && <AdminDashboard />}
              {isAdmin && (
                <>
                  {tela === 'estoque' && <Estoque />}
                  {tela === 'veiculos' && <Veiculos />}
                  {tela === 'equipe' && <Equipe />}
                </>
              )}
            </div>
          </div>
        </main>

        <footer className={`absolute bottom-0 left-0 w-full h-8 flex items-center justify-center ${tema.corBase} border-t border-black/20 no-print z-20`}>
          <p className="text-[9px] font-bold text-white uppercase tracking-widest opacity-80 text-center">InnovaSocial Todos os Direitos Reservados @2026 - Mirassol/SP</p>
        </footer>
      </div>
    </div>
  );
}
